module.exports = __webpack_public_path__ + "static/ever-10-logo-e9480715b0a338810602c2db4717707e.png";